import { TabStyles } from '@tableau/widgets';

import { CSSProperties } from 'react';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { imgPath } from '../../common/utilities/ImgUrl';
import { cssClass } from '../../style';

const CSS_PREFIX = 'WelcomeChannel';
const COLOR_OFF_WHITE = 'rgba(255, 255, 255, 0.9)';
const LINK_DEFAULT = '#DCECF9';
const LINK_HIGHLIGHT = '#AED3EF';
export namespace WelcomeChannelStyles {

  export const root = cssClass(CSS_PREFIX, 'root', {
    position: 'relative',
    backgroundColor: TabStyles.Colors.ApplicationBlue,
    padding: '26px 36px',
    backgroundImage: `${getBackgroundImageUrl('home_welcome_screen_trend_line.png')} ,${getBackgroundImageUrl('home_welcome_screen_main.png')}`,
    backgroundPosition: 'bottom left, bottom right',
    backgroundSize: 'contain, contain',
    backgroundRepeat: 'repeat-x, no-repeat',
  });

  export const footer = cssClass(CSS_PREFIX, 'footer', {
    backgroundColor: TabStyles.Colors.ApplicationBlue,
    padding: '6px 34px',
    color: COLOR_OFF_WHITE,
    fontSize: TabStyles.Typography.Sizing.Default,
    marginTop: '2px',
    outlineStyle: 'none',
    position: 'relative',
    $nest: {
      'p': {
        margin: '0 2px',
        lineHeight: '20px'
      },
      'a': {
        color: LINK_DEFAULT,
        fontWeight: 'bold',
        $nest: {
          '&:hover': {
            color: LINK_HIGHLIGHT,
          }
        }
      }
    }
  });

  export const editModeOutline = cssClass(CSS_PREFIX, 'editModeOutline', {
    outline: '1px dashed',
  });

  export const closeButton: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    width: 30,
    height: 30,
    cursor: 'pointer',
  };

  const sharedCloseButtonFooter: NestedCSSProperties = {
    position: 'absolute',
    top: 5,
    right: 5,
    background: 'none',
    opacity: 0.5,
    lineHeight: 0,  // Default line height added extra height
    $nest: {
      '&:hover': {
        opacity: 1,
      }
    }
  };

  export const closeButtonContainer = cssClass(CSS_PREFIX, 'close_button_container', {
    ...sharedCloseButtonFooter,
    top: 5,
    right: 5
  });

  export const closeButtonFooterContainer = cssClass(CSS_PREFIX, 'close_button_footer_container', {
    ...sharedCloseButtonFooter,
    top: 2,
    right: 5
  });

  export const header = cssClass(CSS_PREFIX, 'header', {
    fontSize: 28,
    fontWeight: 'normal',
    color: COLOR_OFF_WHITE,
    marginTop: 12,
    marginBottom: 10,
    lineHeight: 1.3,
  });

  export const subheader = cssClass(CSS_PREFIX, 'subheader', {
    fontSize: 14,
    fontWeight: 'normal',
    lineHeight: '21px',
    color: COLOR_OFF_WHITE,
    marginTop: 14,
    marginBottom: 26,
  });

  export const links = cssClass(CSS_PREFIX, 'links', {
    marginTop: 26,
    marginBottom: 0,
    color: TabStyles.Colors.WhiteTransparentLine,
    fontWeight: 'lighter',
  });

  export const link = cssClass(CSS_PREFIX, 'link', {
    fontWeight: 'bold',
    color: LINK_DEFAULT,
    fontSize: TabStyles.Typography.Sizing.Default,
    $nest: {
      '&:hover': {
        color: LINK_HIGHLIGHT,
      }
    }
  });

  export const linkDivider = cssClass(CSS_PREFIX, 'link-divider', {
    padding: '0 5px',
  });
}

export function getBackgroundImageUrl(imageLocation: string) {
  return 'url("' + imgPath(imageLocation) + '")';
}
